import { Checkbox } from '@viapeople/components'
import type { CalibrationParticipant } from '../types'

interface CalibrationUserBoxProps {
	participant: CalibrationParticipant
	onSelectionChange: (participantId: string, selected: boolean) => void
}

export function CalibrationUserBox({ participant, onSelectionChange }: CalibrationUserBoxProps) {
	const fullName = `${participant.firstName} ${participant.lastName}`

	const handleSelectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onSelectionChange(participant.id, e.target.checked)
	}

	return (
		<div className={'bg-neutral-50 p-4 rounded-md gap-2 items-center border-neutral-200'}>
			<Checkbox label={fullName} checked={participant.selected} onChange={handleSelectionChange} />
			<p>{participant.status}</p>
		</div>
	)
}
